import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  checkAll() {
    this.checkboxTargets.forEach((el) => (el.checked = true))
  }

  uncheckAll() {
    this.checkboxTargets.forEach((el) => (el.checked = false))
  }
}
